export default __webpack_public_path__ + "6371bc3c72b8d0cc0f859759d45398d0.png";